import { SmeWebTelemetry } from '../diagnostics/sme-web-telemetry';

export class AzureLogging {
    public submitCreateResourceTelemetry(dependentResourceIds?: string[]): void {
        const azureResourceData = {
            action: 'CreateAzureDeployment',
            resourceURI: dependentResourceIds
        };
        SmeWebTelemetry.traceAction(
            document.body,
            {
                content: azureResourceData,
                actionType: 'A'
            }
        );
    }
}
